import { BranchesRetriever, LeaguesRetriever } from "./Retriever";
import { LibConfig } from "./init";
export { init } from "./init";
var branchesRetriever = new BranchesRetriever();
var leaguesRetriever = new LeaguesRetriever();
export var loadLeagues = leaguesRetriever.load.bind(leaguesRetriever);
export var loadBranches = branchesRetriever.load.bind(branchesRetriever);
export var setRegionIds = function (regionIds) {
    LibConfig.regionIds = regionIds;
};
export var mocks = {};
if (process.env.NODE_ENV === "development") {
    mocks = require("./Mocks");
}
//# sourceMappingURL=index.js.map